<template>
  <div class="page-outbox">
  	<!--表单-->
  	<form name="addrForm" class="addr-form" action="javascript:void(0)">
  		<!--公司还是个人-->
  		<div class="invoice-type">
	  		<p class="invoice-type-item" @click="setInvoiceType('1')"><i class="mint-checkbox-core" :class="{'checked':invoiceInfo.ci_type=='1'}"></i>普通发票</p>
	  		<p class="invoice-type-item" @click="setInvoiceType('2')"><i class="mint-checkbox-core" :class="{'checked':invoiceInfo.ci_type=='2'}"></i>专用发票 </p>
  		</div>
  		<template>
  			<!--开票抬头-->
  			<mt-field label="开票抬头" class="inputcontent" readonly placeholder="请输入开票抬头" v-model="invoiceInfo.ci_title"></mt-field>
  			<!--税号-->
  			<mt-field label="税号" class="inputcontent" placeholder="请输入税号" v-model="invoiceInfo.ci_vatno"></mt-field>
  		</template>
			<template v-if="invoiceInfo.ci_type=='2'">
				<!--开户行-->
	  		<mt-field label="开户行" class="inputcontent" placeholder="请输入开户行" v-model="invoiceInfo.ci_bank"></mt-field>
		  	<!--银行账号-->
		  	<mt-field label="银行账号" class="inputcontent" placeholder="请输入银行账号" type="number" v-model="invoiceInfo.ci_bknum"></mt-field>

		  	<!--开票地址-->
		  	<mt-field label="开票地址" class="inputcontent" placeholder="请输入开票地址" type="textarea" v-model="invoiceInfo.ci_addr"></mt-field>
		  	<!--开票电话-->
		  	<mt-field label="开票电话" class="inputcontent" placeholder="请输入开票电话" type="number" v-model="invoiceInfo.ci_phone"></mt-field>
		  </template>

  		<!--设为默认地址-->
	  	<p class="set-default-group" @click="setDefault"><i class="mint-checkbox-core" :class="{'checked':invoiceInfo.ci_if_default=='1'}"></i>设为默认值</p>
	  	<!--保存 取消-->
	  	<div class="opr-group">
	  		<mt-button size="large" plain @click="$router.back(-1)">取消</mt-button>
	  		<div class="btn-div"></div>
	  		<mt-button size="large" type="danger" plain @click="deleteInvocie" v-if="!isNew">删除</mt-button>
	  		<div class="btn-div"></div>
	  		<mt-button size="large" type="danger" @click="saveInvocie">保存</mt-button>
	  	</div>

  	</form>

  </div>
</template>

<script>
  import AddrSelector from 'basic/addrSelector/addrSelector'
	export default {
    name: 'editInvocie',
    data () {
      return {
      	invoiceInfo:{
      		ci_addr:"",
					ci_bank:"",
					ci_bknum:"",
					ci_id:"",
					ci_if_default:"1",
					ci_phone:"",
					ci_title:this.$store.state.userInfo.cus_company,
					ci_type:"1",
					ci_vatno:"",
      	},
        isNew:false,
        invoiceType:'common'
      }
    },
    mounted(){
    	//获取数据
    	if(this.$route.query.invoiceId){
        this.getDetail();
    	}else{
    		this.isNew=true;
    	}
    	//获取焦点时移到页面可见区域
    	$('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
			 var dom=e.target;
				setTimeout(function(){
					dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
				}, 200);
			})
    },
    methods:{
    	setInvoiceType(type){
    		if(this.invoiceType!=type){
    			this.invoiceInfo.ci_type=type;
    			this.$nextTick(function(){
    				//获取焦点时移到页面可见区域
			    	$('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
						 var dom=e.target;
							setTimeout(function(){
								dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
							}, 200);
						})
	    		})

    		}
    	},
      deleteInvocie(){
      	var that=this;
      	this.$messagebox.confirm('确定删除这条数据？','温馨提示',{callback:function(type){
      		if(type=='confirm'){
      			that.$cHttp.post('cusinvoice/delete',{
              partner:that.$systemConfig.partner,
              apikey:that.$systemConfig.apikey,
              ci_id:that.$route.query.invoiceId
            }).then((res)=>{
              console.log(res)
              if(res.status&&res.status==1){
                that.$router.go(-1);
              }else{
                that.$toast('删除失败')
              }
            }).catch((msg)=>{
              that.$toast(msg);
            })
      		}
      	}})
      },
      saveInvocie(){
      	if(this.$route.query.invoiceId){
          this.$cHttp.post('cusinvoice/edit',{
            partner:this.$systemConfig.partner,
            apikey:this.$systemConfig.apikey,
            user_id:this.$store.state.userInfo.user_id,
            ...this.invoiceInfo
          }).then((res)=>{
            console.log(res)
            if(res.status&&res.status==1){
              if(this.$route.query.isSubSelect==1){
                this.$router.go(-2);
                this.$store.commit('setSelectedInvoiceData',Object.assign(this.invoiceInfo));
              }else{
                this.$router.go(-1);
              }

            }else{
              this.$toast(res.error_msg);
            }
          }).catch((msg)=>{
            this.$toast(msg);
          })
      	}else{
      	  this.$cHttp.post('cusinvoice/add',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          ...this.invoiceInfo
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            if(this.$route.query.isSubSelect==1){
              this.$router.go(-2);
              this.$store.commit('setSelectedInvoiceData',Object.assign(this.invoiceInfo));
            }else{
              this.$router.go(-1);
            }

          }else{
            this.$toast(res.error_msg);
          }
        }).catch((msg)=>{
          this.$toast(msg);
        })
      	}
      },
    	setDefault(){
    		this.invoiceInfo.ci_if_default=this.invoiceInfo.ci_if_default=='1'?'0':'1';
    	},
    	getDetail(){
        this.$cHttp.post('cusinvoice/detail',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          ci_id:this.$route.query.invoiceId
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            this.invoiceInfo=res.data;
          }else{
            this.$toast('暂无数据')
          }
        }).catch((msg)=>{
          this.$toast(msg);
        })
      }
    },
    components:{
       AddrSelector
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.page-outbox{
		padding-bottom: .4rem;
		background-color: #eee;
	}
	.addr-form{
		.receive-info-title{
			padding: .08rem .1rem;
			font-size: .14rem;
			color: #999;
		}
		.set-default-group,.invoice-type-item{
			padding: 10px 15px;
			padding-left: .25rem;
			font-size: .14rem;
			color: #666;
			background-color: #fff;
			.mint-checkbox-core{
				margin-right: .1rem;
				&.checked{
					background-color: $mainColor;
    			border-color: $mainColor;
    			&:after{
    				border-color: #fff;
    				transform: rotate(45deg) scale(1);
    			}
				}
			}

		}
		.invoice-type{
			display: flex;
			margin-bottom: .04rem;
			text-align:center;
			.invoice-type-item{
				flex: 1;
			}
		}
		.opr-group{
			margin-top: .4rem;
			padding: 0 .15rem;
			display: flex;
			.btn-div{
				min-width: .2rem;
			}
		}
	}
</style>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
	.addr-form{
		.mint-cell{
			padding: 0 .1rem;
			min-height: .4rem;
			border-bottom: 1px solid #ddd;
			.mint-cell-wrapper{
				font-size: .14rem;
				color: #333;
				.mint-cell-title{
					padding-right: .1rem;
					width: auto;
					min-width: .6rem;
					color: #666;
					text-align: right;
				}
        .mint-field-core{
          max-width: none;
          text-align: left;
        }
			}
			&.is-textarea{
				.mint-cell-wrapper{
					align-items: flex-start;
					.mint-field-core{
						font-family:inherit;
					}
				}
			}
		}
		.opr-group{
			.mint-button{
				min-width: .65rem;
				height:.35rem;
				font-size: .16rem;
				border-radius: .02rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/editInvoice/editInvoice.vue